import { render } from "./OfficeIcon.vue?vue&type=template&id=fbbb468c&scoped=true"
import script from "./OfficeIcon.vue?vue&type=script&lang=js"
export * from "./OfficeIcon.vue?vue&type=script&lang=js"

import "./OfficeIcon.vue?vue&type=style&index=0&id=fbbb468c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbbb468c"]])

export default __exports__